import React from 'react';
import Stars from 'atomic/stars';
import timeStamp from 'helpers/time-stamp';
import Icon from 'atomic/icon';
import Circle from 'atomic/circle/circle';
import ProductOpinionAssessment
    from 'modules/product/views/components/product-opinion-section/components/product-opinion-list/components/product-opinion-assessment';

import './product-opinion.scss';

interface ProductOpinionProps {
    rating: number;
    author: string;
    content: string;
    timestamp: number;
    likes: number;
    pros: string[];
    cons: string[];
}

const ProductOpinion: React.FC<ProductOpinionProps> = ({ rating, author, content, timestamp, likes, pros, cons }) => {
    const date = timeStamp(timestamp);

    return (
        <div className="opinion">
            <div className="opinion__header">
                <Stars
                    width={rating}
                    inline={true}
                    size="md"
                    className="opinion__header__stars"
                />
                <span className="opinion__header__author">
                    {author}
                </span>
                {
                    date && (
                        <span className="opinion__header__date">
                            {date}
                        </span>
                    )
                }
            </div>
            <div className="opinion__content">
                {content}
            </div>
            <div className="opinion__details">
                <ProductOpinionAssessment
                    pros={pros}
                    cons={cons}
                />
                <div className="opinion__details__bottom">
                    <div className="opinion__details__bottom__likes">
                        Czy ta opinia była przydatna?
                        <Circle
                            hoverEffect={false}
                            tag="span"
                            background="fifth"
                            border="transparent"
                            color="secondary"
                        >
                            <Icon name="thumbs-up" color="secondary" size={20} />
                        </Circle>
                        {likes}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductOpinion;
